import React from 'react'
import { Translation } from '../../contexts/TranslationContext'
import style from './FoundProblemBanner.module.sass'

type FoundProblemBannerProps = {
	openModal: () => void
}

export const FoundProblemBanner = React.memo(function FoundProblemBanner(props: FoundProblemBannerProps) {
	return (
		<button className={style.wrapper} onClick={props.openModal}>
			<div className={style.title}>
				<Translation tr="foundProblemBanner.title" />
			</div>
			<Translation tr="foundProblemBanner.subtitle" />
			<div className={style.buttonWrapper}>
				<Translation tr="foundProblemBanner.button" />
			</div>
		</button>
	)
})
